export const ALL = 'ALL';
export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const RESET = 'RESET';

export default {
    ALL,
    ADD_TO_CART,
    REMOVE_FROM_CART,
    RESET
};
